import React from 'react'
import OnlinePkBanner from '../../../assets/images/front/online-pk-5-banner.png'
import OnlinePkBannerMobile from '../../../assets/images/front/online-pk-5-banner-mobile.png'
import OnlinePk5BannerGraphics from '../../../assets/images/front/svg/prezencne-pk-9-banner-graphics.svg'
import OnlinePk5BannerButton from '../../../assets/images/front/svg/prezencne-pk-5-button.svg'
import Image690 from '../../../assets/images/front/690.png'
import ImageHand from '../../../assets/images/front/ruka.png'
import SkolaBannerSecondary from '../../../assets/images/front/skola-banner-secondary.png'
import SkolaBannerSecondaryMobile from '../../../assets/images/front/skola-banner-secondary-mobile.png'
import ArrowRightBlue from '../../../assets/images/front/svg/arrow-right-blue.svg'
import ArrowRightGreen from '../../../assets/images/front/svg/arrow-right-green.svg'
import Signpost3 from '../../../assets/images/front/signpost-3.png'
import Signpost4 from '../../../assets/images/front/signpost-4.png'
import Reviews from '../../../components/Front/Reviews/Reviews'
import { useHistory } from 'react-router-dom'
import { routesURLs } from '../../../Routes'
import { useQuery } from 'react-query'
import { getPersonalTestTerms, getCities, getPersonalTests } from '../../../moduls/personal-tests'
import { PersonalTestType } from '../../../services/types'

export const routeWithParams = (route: string, params: Record<string, string | number>) => {
  return Object.entries(params).reduce(
    (acc, [key, value]) => acc.replace(`:${key}`, encodeURIComponent(value.toString())),
    route
  )
}

const Pn9: React.FC = () => {
  const history = useHistory()
  const { data: citiesTests } = useQuery(['personal-tests'], getCities)
  const { data: personalTests } = useQuery(
    ['personal-tests', { id: citiesTests && citiesTests[0]?.id }],
    getPersonalTests
  )
  const currentTest =
    personalTests &&
    personalTests.find((test: PersonalTestType) => test.name === 'Přijímačky na místě – 9. třída')
  const { data: onsiteTests = [], isLoading } = useQuery(
    ['onsite-tests', { id: '9TRIDA' }],
    getPersonalTestTerms
  )

  return (
    <>
      <div className="container relative mx-auto md:px-4 mt-[52px] lg:mt-[84px] mb-[30px] md:mb-[50px]">
        <img
          src={OnlinePkBanner}
          alt=""
          className="w-full min-h-[350px] h-auto hidden md:block object-cover rounded-b-3xl"
        />
        <img
          src={OnlinePkBannerMobile}
          alt=""
          className="w-full min-h-[350px] h-auto md:hidden object-cover"
        />
        <div className="absolute left-[50%] translate-x-[-50%] md:translate-x-0 md:left-8 top-4 w-[calc(100%-16px)] md:w-full px-4">
          <img
            src={OnlinePk5BannerGraphics}
            alt=""
            className="w-full max-w-[585px] h-auto object-cover"
          />
        </div>
        <div className="absolute right-[-50%] translate-x-[-50%] md:translate-x-0 bottom-10 md:right-20 md:bottom-20 flex md:block items-center justify-center w-full md:w-auto">
          <span
            onClick={() =>
              history.push(routesURLs.personalTests + `/${citiesTests?.[0]?.id}?courseId=9TRIDA`)
            }
            className="cursor-pointer inline-block text-2xl md:text-5xl pt-3 text-white bg-[#00A0E3] hover:bg-[#0183BA] tracking-wide leading-tight px-10 py-2 rounded-xl transition-colors duration-200 relative"
          >
            přihlásit se
            <img
              src={OnlinePk5BannerButton}
              alt=""
              className="absolute top-[30%] translate-y-[-50%] -right-10 w-[100px] hidden md:block"
            />
            <img src={Image690} alt="" className="absolute w-[60px] -top-10 -right-8 md:hidden" />
            <img
              src={ImageHand}
              alt=""
              className="absolute w-[60px] -bottom-9 left-[50%] translate-x-[-50%] md:hidden"
            />
          </span>
        </div>
      </div>
      <div className="bg-[#00A0E3] w-full py-8 px-4 mb-[30px] md:mb-[50px]">
        <h2 className="text-wrapper-16 mb-6 text-white text-center">aktuální termíny</h2>
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-12 gap-2 w-full max-w-[820px] mx-auto">
            {!isLoading && onsiteTests.length === 0 && (
              <p className="text-white text-center col-span-12">
                Nejsou k dispozici žádné termíny.
              </p>
            )}
            {isLoading && (
              <p className="text-white text-center col-span-12">Načítám aktuální termíny…</p>
            )}
            {onsiteTests.map((term) => {
              const fullDate = new Date(term.date_from)
              const dateStr = fullDate.toLocaleDateString('cs-CZ', {
                day: 'numeric',
                month: 'long'
              })

              const timeStr = term.time_from

              const locationText = `${term.location.street_name} - ${term.location.street_number}`
              const isFull = term.capacity <= 0
              const isRegistered = term.is_registered

              const renderButton = () => {
                if (isRegistered) {
                  return (
                    <span className="rounded-lg text-lg text-white pt-1 px-3 bg-[#0183BA]">
                      Registrován
                    </span>
                  )
                }

                if (isFull) {
                  return (
                    <span className="rounded-lg text-lg text-white pt-1 px-3 bg-[#FF7070]">
                      vyprodáno
                    </span>
                  )
                }

                return (
                  <a
                    href={`${routesURLs.personalTests}/${citiesTests?.[0]?.id}?courseId=9TRIDA&termId=${term.id}`}
                    className="rounded-lg text-lg text-white pt-1 px-3 bg-[#A8CD00]"
                  >
                    přihlásit se
                  </a>
                )
              }

              return (
                <div key={term.id} className="col-span-12">
                  <div className="hidden md:flex flex-row items-center justify-between bg-white rounded-lg p-2 rounded-lg">
                    <span className="text-lg text-[#0183BA] w-140px">{dateStr}</span>
                    <span className="text-lg text-[#0183BA] w-80px">{timeStr}</span>
                    <span className="text-lg text-[#0183BA]">{locationText}</span>
                    {renderButton()}
                  </div>
                  <div className="flex md:hidden flex-col bg-white rounded-lg p-2 rounded-lg">
                    <div className="mb-3">
                      <span className="text-lg text-[#0183BA]">{locationText}</span>
                    </div>
                    <div className="flex justify-between items-center">
                      <div>
                        <span className="text-lg text-[#0183BA] leading-tight">{dateStr}</span>
                        <br />
                        <span className="text-lg text-[#0183BA] leading-tight">{timeStr}</span>
                      </div>
                      {renderButton()}
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
      <div className="px-4">
        <div className="container mx-auto max-w-[560px] mb-[30px] md:mb-[50px]">
          <h2 className="text-[25px] mb-6 text-[#0183BA] text-center">
            S námi Vás u přijímaček nic nepřekvapí!
          </h2>
          <p className="mb-4">
            <span className="text-[#00A0E3] font-bold">DOHLAVY</span> pořádá přijímačky nanečisto
            pro všechny žáky 9. tříd.
          </p>
          <ul className="font-myriad is-pure-list">
            <li className="flex items-start mb-1">
              <img src={ArrowRightBlue} alt="" className="mt-1 me-1" />
              Testy z matematiky a českého jazyka dle metodiky Cermat.
            </li>
            <li className="mb-1">
              <span className="flex items-start">
                <img src={ArrowRightBlue} alt="" className="mt-1 me-1" />
                Testování probíhá ve stejných podmínkách jako u ostrých přijímaček:
              </span>
              <ul className="ms-8 is-pure-list">
                <li className="flex items-start mb-1">
                  <img src={ArrowRightGreen} alt="" className="mt-1 me-1" />
                  časové limity
                </li>
                <li className="flex items-start mb-1">
                  <img src={ArrowRightGreen} alt="" className="mt-1 me-1" />
                  záznamové archy
                </li>
                <li className="flex items-start mb-1">
                  <img src={ArrowRightGreen} alt="" className="mt-1 me-1" />
                  povolené pomůcky
                </li>
              </ul>
            </li>
            <li className="flex items-start mb-1">
              <img src={ArrowRightBlue} alt="" className="mt-1 me-1" />
              Diskuze s lektorem po testu + prostor na dotazy studentů.
            </li>
            <li className="flex items-start mb-1">
              <img src={ArrowRightBlue} alt="" className="mt-1 me-1" />
              Video s detailním vysvětlením celého testu - dostupné až do konce školního roku.
            </li>
            <li className="flex items-start">
              <img src={ArrowRightBlue} alt="" className="mt-1 me-1" />
              Výsledky testu + srovnání s ostatními řešiteli pro lepší přehled o úspěšnosti.
            </li>
          </ul>
        </div>
        <div className="container relative mx-auto">
          <img src={SkolaBannerSecondary} alt="" className="hidden md:block rounded-3xl" />
          <img src={SkolaBannerSecondaryMobile} alt="" className="block md:hidden rounded-3xl" />
          <div className="grid grid-cols-12 gap-4 absolute top-5 left-8 pe-8 md:left-30 md:top-15">
            <div className="col-span-12 md:col-span-9 lg:col-span-6 flex flex-col text-center md:text-left">
              <h3 className="text-[25px] text-[#00A0E3] mb-3 md:mb-2">Nehodí se vám termíny?</h3>
              <div className="mb-6 leading-tight text-[25px] text-[#0183BA]">
                vyzkoušejte přijímačky nanečisto on-line <br className="hidden md:block" />z pohodlí
                vašeho domova
              </div>
              <span
                onClick={() => history.push(routesURLs.pn9Online)}
                className="inline-block text-white leading-tight text-[25px] bg-[#A8CD00] hover:bg-[#8FB200] rounded-xl pt-3 py-2 px-4 transition-colors duration-200 me-auto"
              >
                Přijímačky nanečisto on-line
              </span>
            </div>
          </div>
        </div>
        <div className="container mx-auto my-12">
          <div className="grid grid-cols-12 gap-4 mx-auto max-w-[820px]">
            <div className="col-span-12 md:col-span-6 relative group text-white">
              <img src={Signpost3} alt="" className="w-full h-auto object-cover rounded-3xl" />
              <span className="block w-full py-2 bg-[#A8CD00] absolute bottom-0 left-0 rounded-b-3xl flex items-center justify-center">
                jak to probíhá?
              </span>
              <div className="absolute top-0 left-0 border rounded-3xl bg-white border-[#A8CD00] w-full h-full p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300 overflow-hidden">
                <h3 className="text-lg text-[#0183BA] mb-0 text-center">jak to probíhá?</h3>
                <p className="leading-tight text-black h-[160px] overflow-auto">
                  Po výběru konkrétního termínu přijímaček nanečisto projdete jednoduchou
                  registrací. Obratem obdržíte potvrzující e-mail. Ve svém uživatelském profilu
                  najdete veškeré důležité informace k vybranému termínu. Ve zvolený den absolvujete
                  přijímačky nanečisto podle instrukcí uvedených ve vašem profilu. Jakmile budou
                  výsledky zpracovány, přijde vám e-mailová notifikace. Ve své osobní zóně pak
                  najdete:
                  <br />
                  – vyhodnocený záznamový arch,
                  <br />
                  – porovnání s ostatními řešiteli,
                  <br />– vysvětlující videa ke všem úlohám.
                </p>
              </div>
            </div>
            <div className="col-span-12 md:col-span-6 relative group text-white">
              <img src={Signpost4} alt="" className="w-full h-auto object-cover rounded-3xl" />
              <span className="block w-full py-2 bg-[#00A0E3] absolute bottom-0 left-0 rounded-b-3xl flex items-center justify-center">
                ZRUŠENÍ REZERVACE TERMÍNU
              </span>
              <div className="absolute top-0 left-0 border rounded-3xl bg-white border-[#00A0E3] w-full h-full p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <h3 className="text-lg text-[#0183BA] mb-0 text-center">
                  ZRUŠENÍ REZERVACE TERMÍNU
                </h3>
                <p className="leading-tight text-black">
                  V případě, že se student nemůže zúčastnit termínu přijímaček nanečisto, na který
                  je přihlášen, je třeba emailem na adresu:{' '}
                  <a href="mailto:prijimacky-nanecisto@dohlavy.cz" className="inline-block">
                    prijimacky-nanecisto@dohlavy.cz
                  </a>
                  rezervaci zrušit nejpozději 24 hodin před termínem, na který je student přihlášen.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="-mb-12">
        <div className="HP">
          <Reviews />
        </div>
      </div>
    </>
  )
}

export default Pn9
